import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Text, IText } from 'app/constants/schemas/Text';
import { attributes, associations, IAttributes, IAssociations } from 'app/constants/schemas/quiz';

export interface IQuestion extends IEntity {
  attributes: IAttributes & {
    id: EntityStringId;
  };
  associations: IAssociations & {
    text: IText;
  };
}

export type Question = Entity<IQuestion>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Question: IEntityType<IQuestion> = vmClient.defineClass({
  typeName: 'Question',
  version: 4,
  lockable: true,
  persisted: true,
  attributes,
  associations: {
    ...associations,
    text: {
      type: Text,
      notNull: true,
    },
  },
});
